export const SpecificEventTypeOptions = [
  { action: "addCommonEvent", text: "הוספת ארוע" },
  { action: "addMichlol", text: "הוספת מכלול" },
  // { action: "addDonation", text: "הוספת תרומה" },
  // { action: "addProduct", text: "הוספת מוצר" },
];



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/parent-events-page/parent-event-type-options/parent-event-type-options.ts